module.exports = __webpack_public_path__ + "static/image/lesson_path_4.svg?c4977453a1172700d690dc4353ff224d";